export default __webpack_public_path__ + "static/6842-508d1eaceee8c4f1260de101301caff4.jpg";